<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        fluid
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">Send a message</p>
        <v-form v-model="isFormValid">
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="subject"
                label="Subject"
                prepend-inner-icon="mdi-format-title"
                required
                hint="This will be the subject of the email received by the tenant"
                :rules="subjectRules"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <p class="body-1 font-weight-bold">Message</p>
          <v-row>
            <v-col class="pb-0">
              <v-textarea
                v-model="emailMessage"
                label="Email Body"
                required
                :rules="emailMessagseRules"
                outlined
                dense
              >
                <template v-slot:prepend-inner>
                  <v-icon small class="mt-1">mdi-email</v-icon>
                </template>
              </v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-textarea
                v-model="smsMessage"
                label="SMS Message"
                counter="140"
                class="pt-0"
                height="100"
                required
                :rules="smsMessagseRules"
                outlined
                dense
              >
                <template v-slot:prepend-inner>
                  <v-icon small class="mt-1">mdi-message-text</v-icon>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>

        <v-card-actions :class="{ 'py-0': mobile }">
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            :disabled="!isFormValid"
            @click="finish"
            >Finish</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      subject: '',
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      durationUnits: [
        { text: 'Day', value: 'day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
        { text: 'Year', value: 'year' }
      ],
      frequency: [{ duration: 1, unit: 'day' }],
      subjectRules: [(v) => v.length > 0 || 'Title cannot be empty'],
      emailMessagseRules: [(v) => v.length > 0 || 'Email body cannot be empty'],
      smsMessagseRules: [
        (v) => v.length > 0 || 'SMS message cannot be empty',
        (v) => v.length <= 140 || 'Please enter less than 140 characters'
      ],
      emailMessage: '',
      smsMessage: '',
      isFormValid: false,
      tenantId: -1
    }
  },
  computed: {
    property() {
      return this.$store.getters['properties/getProperty']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(params) {
      const { tenantId, dueDate } = params
      this.tenantId = tenantId
      this.loading = false
      this.dialog = true
      this.emailMessage = `Dear Tenant,\nYour check dated ${dueDate} was not cleared by the bank. Please settle the amount immediately to avoid incurring any penalties. Thank you.\n\n${this.property.propertyName}`
      this.smsMessage = `Your check for ${this.property.propertyName} on ${dueDate} was not cleared by the bank. Please settle the amount to avoid incurring penalties.`
      this.subject = `${dueDate} check not cleared`
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.loading = true
        const success = await this.$store.dispatch(
          'pdcs/sendMessageNotClearedAction',
          {
            subject: this.subject,
            emailMessage: this.emailMessage,
            smsMessage: this.smsMessage,
            tenantId: this.tenantId
          }
        )

        this.loading = false
        this.dialog = false

        if (success) {
          this.$root.$confirm({
            title: 'Send Message',
            message: `The message has been sent.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          this.resolve(true)
        }
      } catch (err) {
        this.$root
          .$confirm({
            title: 'Send Message Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
            this.reject(false)
          })
      }
    },
    cancel() {
      this.dialog = false
      this.resolve(false)
    }
  }
}
</script>

<style>
p {
  margin-bottom: 0 !important;
}
</style>
